



























































import Vue from "vue";

export default Vue.extend({
    props: {
        ariaLabelledby: {
            type: String,
            required: false,
            default: "modal-title"
        },
        ariaDescribedby: {
            type: String,
            required: false,
            default: ""
        },
        title: {
            type: String,
            required: false,
            default: ""
        },
        titleId: {
            type: String,
            required: false,
            default: "modal-title"
        },
        subtitle: {
            type: String,
            required: false,
            default: ""
        },
        onOpeningFocusOnId: {
            type: String,
            required: false,
            default: null
        },
        isMobileModal: {
            type: Boolean,
            required: false,
            default: false
        },
        titleHidden: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            modalOpener: document.activeElement as HTMLElement, // Save element that trigger the open modal action
            firstFocusableElement: null as unknown as HTMLElement,
            lastFocusableElement: null as unknown as HTMLElement,
            documentScrollTop: 0 as number,
            isMobile: true,
        };
    },
    computed: {
        canBeClose: function(): boolean {
            return this.$store.getters["ModalModule/getCanBeClose"];
        }
    },  
    mounted: function() {
        Vue.nextTick(() => {
            this.documentScrollTop = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ).scrollTop;

            // Get the scrollBar width
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;


            if (document.documentElement.classList.contains("js-fullscreen")) {
                // Add a js-fullscreen--nested class on html tag (disable scroll in css for nested modal)
                document.documentElement.classList.add("js-fullscreen--nested");
            } else {
                // Add a js-fullscreen class on html tag (disable scroll in css)
                document.documentElement.classList.add("js-fullscreen");
            }


            // Add padding right to mainContainer to avoid content shifting to the right when scrollbar disapear
            // Keep in mind that fixed element (e.g top-navigation and property-page-header) should also adapt their position. This is handle specificaly in concerned component
            const mainContainer = document.getElementById("main-container");

            if (mainContainer !== null) {
                mainContainer.setAttribute("style", "padding-right:" + scrollBarWidth + "px;");
            }

            this.$store.commit("ModalModule/setWindowScrollBarWidth", scrollBarWidth);
            this.$store.commit("ModalModule/openModal");

            this.$emit("contentMounted");

            // Responsive Behavior
            /* istanbul ignore next */
            this.$responsive.registerMediaQuery("from-desktop", () => {
                this.setupFocusJail();
                this.isMobile = false;
            }, () => {
                this.setupFocusJail();
                this.isMobile = true;
            });
        });

    },
    destroyed: function() {
        // Set focus back on the element that trigger the modal opening
        this.modalOpener.focus();

        if (document.documentElement.classList.contains("js-fullscreen--nested")) {
            document.documentElement.classList.remove("js-fullscreen--nested");
        } else {
            // Remove Modal-Open class on html tag
            document.documentElement.classList.remove("js-fullscreen");
        }

        window.scroll(0, this.documentScrollTop);

        this.$store.commit("ModalModule/closeModal");

        // Remove padding-right on mainContainer
        const mainContainer = document.getElementById("main-container");

        if (mainContainer !== null) {
            mainContainer.removeAttribute("style");
        }
    },
    methods: {
        closeModal: function() {
            this.$emit("closeModal");
        },
        setupFocusJail: function() {

            let focusableElements = [] as Array<HTMLElement>;

            // Get all focusable elements of the modal
            focusableElements = Array.from(this.$el.querySelectorAll(
                "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]"
            ));

            const visibleFocusableElements = focusableElements.filter(element => this.isVisible(element));

            // Get the first focusable element
            if (focusableElements.length > 0) {
                this.firstFocusableElement = visibleFocusableElements[0];
            }

            // Set focus on first focusable element of the modal or on a specific element
            let focusTargetElement = null;

            if(this.onOpeningFocusOnId !== null) {
                focusTargetElement = document.getElementById(this.onOpeningFocusOnId);
            }

            if(this.onOpeningFocusOnId !== null && focusTargetElement !== null) {
                focusTargetElement.focus();
            } else if(this.firstFocusableElement !== undefined) {
                (this.firstFocusableElement as HTMLElement).focus();
            }

            // Save last focusable element of the modal
            this.lastFocusableElement = visibleFocusableElements[focusableElements.length - 1];
        },
        handleTabPress: function(event: MouseEvent) {
            if (event.shiftKey === true) {
                //Tab backward

                // Specific case if first focusable element is a radio button
                // When you focus backward on a radio group, the browser focus on the last radio button of the group,
                // but leave the group on the next tab backward.
                // So the original condition (activElement === firstFocusableElement) is never met
                // Do the check on the grandparent (the fieldset) to achieve the same desired behavior
                if(this.firstFocusableElement && this.firstFocusableElement.getAttribute("type") === "radio") {
                    const firstFocusableElementGrandParent = this.firstFocusableElement.parentElement ? this.firstFocusableElement.parentElement.parentElement : "";
                    if(document.activeElement && document.activeElement.parentElement) {
                        const activeElementGrandParent = document.activeElement.parentElement.parentElement;
                        if(this.lastFocusableElement && activeElementGrandParent === firstFocusableElementGrandParent) {
                            event.preventDefault();
                            this.lastFocusableElement.focus();
                        }
                    }


                } else {
                    if (document.activeElement === this.firstFocusableElement) {
                        event.preventDefault();
                        this.lastFocusableElement.focus();
                    }
                }
            } else {
                // Tab forward
                if (document.activeElement === this.lastFocusableElement) {
                    event.preventDefault();
                    this.firstFocusableElement.focus();
                }
            }
        }
    }
});
